<template>
  <v-container>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
      <template v-if="CheckAdmin">
        <v-card>
          <v-card-title>
            ตั้งค่าเงื่อนไขประจำตำแหน่ง
          </v-card-title>

          <v-container>
            <v-card>
              <v-row
                  class="md12 d-flex justify-center"
              >
                <v-col
                    cols="12"
                    md="12">
                  <p style="text-align: center;font-weight: bold;font-size: 20px">
                    ข้อมูลเงื่อนไขตำแหน่ง : <span
                      style="color: coral;font-weight: bold">{{ PositionName }}</span>
                  </p>
                  <!--<template>
                      <div>
                          <v-treeview
                                  :items="level_position"
                                  :dense="dense"
                                  :selectable="selectable"
                                  :activatable="activatable"
                                  :hoverable="hoverable"
                                  :open-on-click="openOnClick"
                                  :selected-color="selectedColor"
                                  :color="color"
                                  :shaped="shaped"
                                  :rounded="rounded"
                          >
                              &lt;!&ndash; <template slot="append" slot-scope="{ item }">
                                   <v-btn @click="addChild(item);">Add child</v-btn>
                               </template>&ndash;&gt;
                              <template slot="label" slot-scope="{ item }">
                                  <span v-html='item.name'> </span>

                                  <v-btn class="mx-5" tile dark x-small color="red"
                                         @click="DeleteItem(item)" icon>
                                      <v-icon dark>mdi-close</v-icon>
                                  </v-btn>

                              </template>
                          </v-treeview>
                      </div>
                  </template>-->
                  <v-data-table
                      :headers="headers"
                      :items="WorkAgeData"
                      class="elevation-1"
                      v-if="TypePosition_M == 'G' || TypePosition_M == 'D'"
                  >
                    <template v-slot:item.PostType="{item}">
                                      <span v-if="item.PostType == 'G'">
                                          ทั่วไป
                                      </span>
                      <div v-else-if="item.PostType == 'D'">
                                          วิชาชีพ
                        <p style="color: #364eff">
                          {{item.dep_name}}
                        </p>
                                      </div>
                      <span v-else>
                                          บริหาร
                                      </span>
                    </template>
                    <template v-slot:item.sExpYeay="{item}">
                                      <span>
                                          {{ parseFloat(item.sExpYeay).toFixed(0) }} ปี
                                      </span>
                    </template>
                    <template v-slot:item.eExpYeay="{item}">
                                      <span v-if="parseInt(item.eExpYeay) == -1">
                                          {{ parseFloat(item.sExpYeay).toFixed(0) }} ปี หรือ มากกว่า
                                      </span>
                      <span v-else>
                                          {{ parseFloat(item.eExpYeay).toFixed(0) }} ปี
                                      </span>
                    </template>
                    <template v-slot:item.action="{item}">
                      <v-btn text color="primary" @click="showCompetency(item)">
                        Competency
                      </v-btn>
                      <v-dialog
                          v-model="dialogShowCourse"
                          width="500"
                          transition="dialog-bottom-transition"
                          :retain-focus="false"
                      >
                        <template v-slot:activator="{on , attrs}">
                          <v-btn text color="green" class="darken-3" @click="showCourse(item)"
                                 v-bind="attrs"
                                 v-on="on"
                          >
                            หลักสูตร
                          </v-btn>
                        </template>
                        <v-card>
                          <v-card-title class="headline grey lighten-2">
                            หลักสูตรที่ต้องการ
                          </v-card-title>

                          <v-card-text>
                            <div style="font-weight: bold">
                              <span>หลักสูตรที่ต้องการ</span>
                            </div>
                           <v-data-table
                             :items="CourseToShow"
                             :headers="headersCourse">
                             <template v-slot:item.full_Detail="{ item }">
                               <div v-html="item.full_Detail"></div>
                             </template>
                           </v-data-table>
                          </v-card-text>

                          <v-divider></v-divider>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="red"
                                text
                                @click="dialogShowCourse = false"
                            >
                              ปิด (Close)
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <v-btn text color="red" @click="DeleteCompetency(item)">
                        ลบ
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card>
            <v-row>
              <v-col
                  cols="12"
                  md="3">
                <v-card
                    outlined>
                  <!--<v-list-item three-line>
                      <v-list-item-content>
                          <div class="overline mb-2" style="color: darkblue;font-weight: bold">เลือกหน่วยงาน
                          </div>
                          <v-list-item-title class="headline mb-1">
                              <v-autocomplete
                                      label="หน่วยงาน">

                              </v-autocomplete>
                          </v-list-item-title>
                      </v-list-item-content>
                  </v-list-item>-->
                  <v-list-item three-line>
                    <v-list-item-content>
                      <div class="overline mb-2" style="color: darkblue;font-weight: bold">
                        เลือกประเภท Competency
                      </div>
                      <v-list-item-title class="headline mb-1">
                        <div class="d-inline">
                          <v-autocomplete label="ประเภท Competency"
                                          :items="TypePosition"
                                          item-value="id"
                                          item-text="value"
                                          v-model="TypePosition_M"
                                          @change="ChangeTypePosition"
                          ></v-autocomplete>
                        </div>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item three-line v-if="TypePosition_M == 'G' || TypePosition_M == 'D'">
                    <v-list-item-content>
                      <div class="overline mb-2" style="color: darkblue;font-weight: bold">
                        เลือกตำแหน่ง
                      </div>
                      <v-list-item-title class="headline mb-1">
                        <div class="d-inline">
                          <v-autocomplete
                              v-model="position_c"
                              label="ตำแหน่ง"
                              :items="PositionsData"
                              item-value="PosCode"
                              item-text="PosName"
                              @change="GetPositionToShow"
                          >
                          </v-autocomplete>
                        </div>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item three-line v-if="TypePosition_M == 'M'">
                    <v-list-item-content>
                      <div class="overline mb-2" style="color: darkblue;font-weight: bold">
                        เลือกตำแหน่งบริหาร
                      </div>
                      <v-list-item-title class="headline mb-1">
                        <div class="d-inline">
                          <v-autocomplete
                              v-model="position_c"
                              label="ตำแหน่งบริหาร"
                              :items="ManagerialData"
                              item-value="supervisor_type_id"
                              item-text="supervisor_type_name"
                              @change="GetManagerialToShow"
                          >
                          </v-autocomplete>
                        </div>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </v-col>
              <v-col
                  cols="12"
                  md="9">

                <v-tabs
                    v-model="tab"
                    background-color="black"
                    dark
                    next-icon="mdi-arrow-right-bold-box-outline"
                    prev-icon="mdi-arrow-left-bold-box-outline"
                    show-arrows
                >
                  <v-tabs-slider color="yellow"></v-tabs-slider>
                  <v-tab
                      key="initData"
                      v-if="TypePosition_M == 'G' || TypePosition_M == 'D'"
                  >
                    บันทึกข้อมูลเริ่มต้น ตำแหน่ง/อายุงาน
                  </v-tab>
                  <v-tab
                      key="initCompetency"
                  >
                    บันทึกข้อมูลเริ่มต้น Competency
                  </v-tab>
                  <v-tab
                      key="initCourse"
                  >
                    บันทึกข้อมูลเริ่มต้น หลักสูตร
                  </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                  <v-tab-item
                      key="initData"
                      v-if="TypePosition_M == 'G' || TypePosition_M == 'D'"
                  >
                    <v-card
                        outlined
                        style="border-color: darkblue;border: 2px solid">
                      <v-card-title>
                        บันทึกข้อมูลเริ่มต้น ตำแหน่ง/อายุงาน
                      </v-card-title>
                      <!--<v-list-item>
                          <v-row class="d-flex justify-center">
                              <v-col
                                      cols="12"
                                      md="4"
                              >
                                  <v-autocomplete label="ประเภทตำแหน่ง" outlined
                                                  :items="TypePosition"
                                                  item-value="id"
                                                  item-text="value"
                                                  v-model="TypePosition_M"
                                  ></v-autocomplete>
                              </v-col>
                          </v-row>
                      </v-list-item>-->
                      <v-list-item>
                        <v-row class="d-flex justify-center">
                          <v-col
                              cols="12"
                              md="4"
                          >
                            <v-autocomplete label="อายุงานเริ่มต้น" outlined
                                            :items="AgeStart"
                                            item-value="id"
                                            item-text="value"
                                            v-model="AgeStart_M"
                            ></v-autocomplete>
                          </v-col>
                          <v-col
                              cols="12"
                              md="2"
                          >
                            <div align="center" class="mt-4">
                              <span style="font-weight: bold">ถึง</span>
                            </div>

                          </v-col>
                          <v-col
                              cols="12"
                              md="4"
                          >
                            <v-autocomplete label="อายุงานสิ้นสุด" outlined
                                            :items="AgeEnd"
                                            item-value="id"
                                            item-text="value"
                                            v-model="AgeEnd_M"
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-list-item>
                      <v-list-item>
                        <v-row class="d-flex justify-center">
                          <v-col
                              cols="12"
                              md="5"
                          >
                            <v-text-field outlined label="ชื่อเรียกตามช่วงอายุงาน (ถ้ามี)"
                                          v-model="AgeName_M"></v-text-field>
                          </v-col>
                          <v-col
                              cols="12"
                              md="5"
                          >
                            <v-textarea outlined label="คำอธิบายเพิ่มเติม (ถ้ามี)"
                                        v-model="AgeDesc_M"></v-textarea>
                          </v-col>
                        </v-row>
                      </v-list-item>
                      <v-list-item v-if="TypePosition_M == 'D'">
                        <v-row class="d-flex justify-center">
                          <v-col
                              cols="12"
                              md="10"
                          >
                            <v-autocomplete
                                :items="DepartData"
                                item-text="dep_name"
                                item-value="dep_id"
                                v-model="FixDep"
                                label="หน่วยงาน"
                                outlined
                                clearable
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-list-item>
                      <v-list-item class="justify-center">
                        <v-btn
                            outlined
                            color="#00796B"
                            style="margin-bottom: 15px"
                            @click="AddWorkAge">
                          บันทึกข้อมูล
                        </v-btn>
                      </v-list-item>
                      <!--<v-list-item>
                          <v-row class="justify-center">
                              &lt;!&ndash;<v-col
                                      cols="12"
                                      md="4">
                                  <v-select
                                          v-model="posi_choose_c"
                                          :items="items"
                                          item-value="id"
                                          item-text="name"
                                          label="ตำแหน่ง"
                                          @change="get_Age_Posi">
                                      <template v-slot:item="{item}">
                                          <span v-html="item.name" style="color: darkslategrey"></span>
                                      </template>
                                      <template slot="selection" slot-scope="data">
                                          <span v-html="data.item.name"></span>
                                      </template>
                                      &lt;!&ndash; <template v-slot:append="{item}">
                                           {{item.title}}
                                       </template>&ndash;&gt;
                                  </v-select>
                              </v-col>
                              <v-col
                                      cols="12"
                                      md="4">
                                  <v-select
                                          v-model="age_choose_c"
                                          :items="ageItem"
                                          item-value="id"
                                          label="อายุงาน">
                                      <template v-slot:item="{item}">
                                           <span v-html="item.name" style="color: #ff6d81">
                                          </span>
                                      </template>
                                      <template slot="selection" slot-scope="data">
                                           <span v-html="data.item.name" style="color: #ff6d81">
                                          </span>
                                      </template>
                                      &lt;!&ndash; <template v-slot:append="{item}">
                                           {{item.title}}
                                       </template>&ndash;&gt;
                                  </v-select>
                              </v-col>&ndash;&gt;
                              <v-col
                                      cols="12"
                                      md="4">
                                  <v-select
                                          v-model="posi_choose"
                                          label="ระดับตำแหน่ง"
                                          :items="items"
                                          item-value="LevelCode"
                                          item-text="LevelName"
                                  >
                                  </v-select>
                              </v-col>
                              <v-col
                                      cols="12"
                                      md="4">
                                  <v-select
                                          :items="Course"
                                          item-text="Course_name"
                                          item-value="Course_code"
                                          v-model="Course_code"
                                          label="หลักสูตร"
                                          required
                                          @change="getCourseType"
                                  ></v-select>
                              </v-col>
                          </v-row>

                      </v-list-item>
                      <v-list-item>
                          <v-row>
                              <v-col
                                      cols="12"
                                      md="6"
                              >
                                  <div class="d-inline">
                                      <v-select
                                              :items="DepartData"
                                              item-text="dep_name"
                                              item-value="dep_id"
                                              v-model="departSel"
                                              label="หน่วยงาน"
                                              disabled
                                      ></v-select>
                                  </div>
                              </v-col>
                              <v-col
                                      cols="4"
                                      md="2"
                              >
                                  <div class="d-inline">
                                      <v-text-field
                                              v-model="course_group"
                                              label="สาขาประเภทหลักสูตร"
                                              disabled
                                              required
                                      ></v-text-field>
                                  </div>
                              </v-col>
                              <v-col
                                      cols="4"
                                      md="2"
                              >
                                  <v-text-field label="จำนวนเครดิต" hide-details="auto"
                                                v-model="General_credit"
                                                disabled
                                  ></v-text-field>
                              </v-col>
                              <v-col
                                      cols="4"
                                      md="2"
                              >
                                  <v-text-field label="จำนวน ช.ม" hide-details="auto"
                                                v-model="Course_hour"
                                                disabled
                                  ></v-text-field>
                              </v-col>
                          </v-row>
                      </v-list-item>
                      <v-list-item class="justify-center">
                          <v-btn
                                  outlined
                                  color="#00796B"
                                  style="margin-bottom: 15px"
                                  @click="AddPositionExpert">
                              เพิ่มเงื่อนไข
                          </v-btn>
                      </v-list-item>-->
                    </v-card>
                  </v-tab-item>
                  <v-tab-item
                      key="initCompetency"
                  >
                    <v-container>
                      <v-card>
                        <v-list-item v-if="TypePosition_M == 'G'">
                          <v-row class="d-flex justify-center">
                            <v-col
                                cols="12"
                                md="6">
                              <v-select
                                  v-model="ChooseAgeData"
                                  :items="WorkAgeData"
                                  item-value="id"
                                  item-text="eExpYeay"
                                  label="เลือกช่วงอายุงาน"
                                  outlined
                                  @change="selectionFunc"
                              >
                                <template v-slot:item="{item}">
                                                          <span style="font-weight: bold"
                                                                v-if="parseInt(item.eExpYeay) != -1">
                                                              อายุงาน {{ parseFloat(item.sExpYeay).toFixed(0) }} ปี - {{ parseFloat(item.eExpYeay).toFixed(0) }} ปี ({{ item.PostType }})
                                                          </span>
                                  <span style="font-weight: bold" v-else>
                                                              อายุงาน {{ parseFloat(item.sExpYeay).toFixed(0) }} ปี เป็นต้นไป ({{ item.PostType }})
                                                          </span>
                                </template>
                                <template v-slot:selection="{item}">
                                                          <span style="font-weight: bold;color: #364eff"
                                                                v-if="parseInt(item.eExpYeay) != -1">
                                                              อายุงาน {{ parseFloat(item.sExpYeay).toFixed(0) }} ปี - {{ parseFloat(item.eExpYeay).toFixed(0) }} ปี ({{ item.PostType }})
                                                          </span>
                                  <span style="font-weight: bold;color: #364eff" v-else>
                                                              อายุงาน {{ parseFloat(item.sExpYeay).toFixed(0) }} ปี เป็นต้นไป ({{ item.PostType }})
                                                          </span>
                                </template>
                              </v-select>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item v-else-if="TypePosition_M == 'M' && position_c != ''">
                          <v-row class="justify-center">
                            <v-col
                                cols="12"
                                md="3">
                              <v-btn outlined color="primary" @click="showCompetency">
                                Show Competency
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-text-field
                            v-model="search"
                            label="ค้นหา (คลิก)"
                            dark
                            flat
                            solo-inverted
                            hide-details
                            clearable
                            clear-icon="mdi-close-circle-outline"
                        ></v-text-field>
                        <v-treeview v-model="selection" :activatable="true" :items="items"
                                    :search="search" :selectable="true" dense>
                          <template v-slot:prepend="{ item, open }">
                            <v-icon v-if="!item.file" color="blue lighten-2">
                              {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                            </v-icon>
                            <v-icon v-else>
                              {{ files[item.file] }}
                            </v-icon>
                          </template>
                          <template v-slot:label="{ item, active }">
                            <div v-if="isMobile" style="cursor: pointer"
                                 @click="ShowDetail(item)">
                                                  <span style="font-size: 12px;color: black" v-if="!active">
                                                      {{ item.name }}
                                                  </span>
                              <span style="font-size: 12px;color: #364eff;font-weight: bold"
                                    v-else>
                                                      {{ item.name }}
                                                  </span>
                            </div>
                            <div v-else style="cursor: pointer" @click="ShowDetail(item)">
                                                  <span style="color:black;font-size: 12px" v-if="!active">
                                                      {{ item.name }}
                                                  </span>
                              <span style="color: #364eff;font-weight: bold;font-size: 12px" v-else>
                                                      {{ item.name }}
                                                  </span>
                            </div>
                          </template>
                          <template v-slot:append="{ item }">
                            <v-row class="d-flex justify-end"
                                   v-if="item.DelvLevel >= '1' && item.children.length == 0">
                              <v-col
                                  cols="2"
                                  md="2">
                                <v-text-field label="เครดิต"
                                              v-model="item.NeedsCredit"
                                              :value="item.NeedsCredit"></v-text-field>
                              </v-col>
                              <v-col
                                  cols="2"
                                  md="2">
                                <v-text-field label="คาดหวัง"
                                              v-model="item.ExpectCredit"
                                              :value="item.ExpectCredit"></v-text-field>
                              </v-col>
                            </v-row>
                          </template>
                        </v-treeview>
                        <v-list-item class="justify-center" style="margin-top: 20px">
                          <v-btn
                              outlined
                              color="#00796B"
                              style="margin-bottom: 15px"
                              @click="AddCompetency">
                            บันทึกข้อมูล
                          </v-btn>
                        </v-list-item>
                      </v-card>
                    </v-container>
                  </v-tab-item>
                  <v-tab-item
                    key="initCourse"
                  >
                    <v-card>
                      <v-card-subtitle>
                        <span style="color: black">บันทึกข้อมูลเริ่มต้นหลักสูตร</span>
                      </v-card-subtitle>
                      <v-card-text>
                        <v-list>
                          <v-list-item>
                            <v-row>
                              <v-col
                                cols="12"
                                md="4"
                                v-if="TypePosition_M == 'G'"
                              >
                                <div>
                                  <span style="font-weight: bold;font-size: 18px">เลือกช่วงอายุงาน</span>
                                </div>
                                <v-radio-group v-model="SelWorkAge" @change="ChooseWorkAgeToCourse">
                                  <v-radio v-for="(posi,idx) in WorkAgeData" :key="idx" :value="posi.id">
                                    <template v-slot:label>
                                                  <span style="font-weight: bold"
                                                        v-if="parseInt(posi.eExpYeay) != -1">
                                                              อายุงาน {{ parseFloat(posi.sExpYeay).toFixed(0) }} ปี - {{ parseFloat(posi.eExpYeay).toFixed(0) }} ปี ({{ posi.PostType }})
                                                          </span>
                                      <span style="font-weight: bold" v-else>
                                                              อายุงาน {{ parseFloat(posi.sExpYeay).toFixed(0) }} ปี เป็นต้นไป ({{ posi.PostType }})
                                                          </span>
                                    </template>
                                  </v-radio>
                                </v-radio-group>
                              </v-col>
                              <v-col
                                cols="12"
                                md="8"
                              >
                                <v-text-field label="ค้นหาหลักสูตร/หน่วยงาน" v-model="searchCourse"></v-text-field>
                                <v-data-table
                                    :search="searchCourse"
                                    v-model="selectedCourse"
                                    :headers="headersCourse"
                                    :items="courseData"
                                    item-key="Course_code"
                                    show-select
                                    class="elevation-1"
                                    v-show="WorkAgeData.length > 0 || TypePosition_M == 'M'"
                                    @item-selected="SaveSelToDb"
                                    @toggle-select-all="toggle_SelectAll"
                                >
                                  <template v-slot:item.full_Detail="{ item }">
                                    <div v-html="item.full_Detail"></div>
                                  </template>
                                </v-data-table>
                              </v-col>
                            </v-row>
                          </v-list-item>
                        </v-list>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <template>
          <v-dialog
              v-model="dialogCompetency"
              max-width="1000"
          >
            <v-card v-if="CompetencyToShow != null">
              <v-card-title class="headline"><span
                  style="color: #42b983;font-weight: bold">ตำแหน่ง: {{ PositionName }}</span></v-card-title>
              <v-card-text>
                <v-row>
                  <v-col
                      cols="12">
                    <v-treeview :activatable="true" :items="CompetencyToShow" dense>
                      <template v-slot:prepend="{ item, open }">
                        <v-icon v-if="!item.file" color="blue lighten-2">
                          {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                        </v-icon>
                        <v-icon v-else>
                          {{ files[item.file] }}
                        </v-icon>
                      </template>
                      <template v-slot:label="{ item, active }">
                        <div v-if="isMobile" style="cursor: pointer">
                                                  <span style="font-size: 12px;color: black" v-if="!active">
                                                      {{ item.name }}
                                                  </span>
                          <span style="font-size: 12px;color: #364eff;font-weight: bold"
                                v-else>
                                                      {{ item.name }}
                                                  </span>
                        </div>
                        <div v-else style="cursor: pointer">
                                                  <span style="color:black;" v-if="!active">
                                                      {{ item.name }}
                                                  </span>
                          <span style="color: #364eff;font-weight: bold" v-else>
                                                      {{ item.name }}
                                                  </span>
                        </div>
                      </template>
                      <template v-slot:append="{ item }">
                        <v-row class="d-flex justify-end"
                               v-if="item.DelvLevel >= '1' && item.children.length == 0">
                          <v-col
                              cols="6"
                              md="6">
                                                  <span style="font-weight: bold;color: #364eff">
                                                      {{ item.NeedsCredit }} เครดิต
                                                  </span>
                          </v-col>
                          <v-col
                              cols="6"
                              md="6">
                                                    <span style="font-weight: bold;color: darkslateblue">
                                                      {{ item.ExpectCredit }} ความคาดหวัง
                                                  </span>
                          </v-col>
                        </v-row>
                      </template>
                    </v-treeview>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="green darken-1"
                    text
                    @click="dialogCompetency = false"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
        <template>
          <v-dialog
              v-model="dialogDeleteCompetency"
              max-width="290"
          >
            <v-card>
              <v-card-title class="headline">ยืนยันการทำรายการ</v-card-title>

              <v-card-text>
                คุณต้องการลบข้อมูล อายุงานที่เลือก ใช้หรือไม่ ??
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    color="green darken-1"
                    text
                    @click="DeleteCompetencyConfirm"
                >
                  ตกลง
                </v-btn>

                <v-btn
                    color="green darken-1"
                    text
                    @click="dialogDeleteCompetency = false"
                >
                  ยกเลิก
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
      </template>
      <template v-else></template>
    </template>
  </v-container>
</template>

<script>
import axios from 'axios'
import ConstData from '../const/Const'
import {mapActions, mapGetters} from 'vuex'
import {ServiceProvider} from '@/resource'

export default {
  name: "PositionPerCourse",
  data() {
    return {
      pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
      maintain: false,
      CourseToShow: [],
      dialogShowCourse: false,
      SelWorkAge: '',
      searchCourse: '',
      selectedCourse: [],
      FixDep: null,
      itemsSel: [],
      CheckAdmin: false,
      competencySelection: [],
      dialogCompetency: false,
      dialogDeleteCompetency: false,
      isMobile: false,
      ChooseAgeData: '',
      selection: [],
      selectionToDb: [],
      dialogDetail: false,
      itemToShow: [],
      CompetencyToShow: [],
      search: null,
      tab: null,
      TypePosition_M: '',
      AgeStart_M: '',
      AgeEnd_M: '',
      AgeName_M: '',
      AgeDesc_M: '',
      AgeDesc: '',
      TypePosition: [
        {
          id: 'G',
          value: 'ทั่วไป',
        },
        {
          id: 'M',
          value: 'บริหาร',
        },
        {
          id: 'D',
          value: 'วิชาชีพ',
        },
      ],
      AgeStart: [],
      AgeEnd: [],
      departSel: '',
      level_position: [],
      PositionName: '',
      position_c: '',
      ageItem: [],
      age_choose_c: '',
      posi_choose_c: '',
      posi_choose: '',
      yearStart: '',
      yearEnd: '',
      General_credit: '',
      Course_hour: '',
      Course_code: '',
      course_group: '',
      courseData: [],
      PositionAllDepart: [],
      headersPosi: [
        {
          text: 'ตำแหน่ง',
          align: 'start',
          sortable: false,
          value: 'position',
        },
        {text: 'รหัสตำแหน่ง', value: 'position_id'}
      ],
      DataPosi: [],
      headersCourse: [
        {text: 'ชื่อหลักสูตร', value: 'full_Detail'}
      ],
      DataCourse: [],
      rules: {
        required: value => !!value || 'Required.',
        counterCourse: value => value.length <= 8 || 'Max 8 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
      items: [],
      dense: false,
      selectable: false,
      activatable: true,
      hoverable: true,
      openOnClick: true,
      shaped: true,
      rounded: true,
      color: 'primary',
      selectedColor: 'accent',
      selectedColors: [
        'accent',
        'teal',
        'red',
        'success',
        'warning lighten-2',
      ],
      headers: [
        {text: 'ประเภท', value: 'PostType'},
        {text: 'ตำแหน่ง', value: 'pos_name'},
        {text: 'อายุงานเริ่มต้น', value: 'sExpYeay'},
        {text: 'อายุงานสิ้นสุด', value: 'eExpYeay'},
        {text: 'ชื่อเรียกประจำระดับ', value: 'WorkExpName'},
        {text: '', value: 'action'},
      ],
      WorkAgeData: []
    }
  },
  computed: {
    ...mapGetters({
      MeData: 'Staff/getMeData',
      levelData: 'Level/getLevel',
      DepartData: 'Depart/getDepart',
      PositionsData: 'Positions/getPosition',
      ManagerialData: 'Positions/getPositionManagerial',
      CourseWorkExp: 'Project/getCourseWorkExp',
      WorkExp: 'Project/getWorkExp',
      Course: 'Course/getCourse',
      Competency: 'Competency/getCompetency',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      PermissionAdmin: 'Permission/getPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      Approve: 'Permission/getApprove',
      MenuPermiss: 'Permission/getMenuPermiss',
      IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
      appColor: 'Page/getColor',
      appHeaderName: 'Page/getHeaderName',
    }),
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initlevelData: 'Level/initLevelData',
      initDepartData: 'Depart/initDepartData',
      initPositionData: 'Positions/initPositionData',
      initPosi_ManagerialData: 'Positions/initPosi_ManagerialData',
      initCourseData: 'Course/initCourseData',
      initCompetencyData: 'Competency/initCompetencyData',
      initCourseWorkExp: 'Project/initCourseWorkExp',
      initWorkExp: 'Project/initWorkExp',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveData: 'Permission/initApproveData',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
      getMenuPermissData: 'Permission/getMenuPermissData',
      getIgnoreMenuPermissData: 'Permission/getIgnoreMenuPermissData',
      changeColor: 'Page/changeColor',
      changeHeaderName: 'Page/changeHeaderName',
      changeTypeProject: 'Project/changeTypeProject',
    }),
    onResize() {
      this.isMobile = window.innerWidth < 600
    },
    init() {
      this.items = []
      this.courseData = []
      /*this.initlevelData().then((res) => {
          if (res) {
              this.levelData.map((level_i, idx) => {
                  this.items.push({
                      ...level_i,
                      id: idx,
                      name: level_i.LevelName,
                      status: 0,
                      children: []
                  })
              })
          }
      })*/
      this.initDepartData()
      this.initPositionData()
      this.initPosi_ManagerialData()
      this.initCourseData().then(res => {
        if (res) {
          if (this.Course.length > 0) {
            this.Course.map(item => {
              this.courseData.push({
                ...item,
                full_Detail: '<div><span style="font-weight: bold;color: #364eff">' + item.Course_name + '</span></div>' +
                    '<div><span style="font-weight: bold;color: darkslategrey">' + item.dep_name + '</span></div>',
                statusReg: false
              })
            })
          }
        }
      })
      this.initCompetencyData().then(res => {
        if (res) {
          this.Competency.map(compe_i => {
            if (compe_i.DelvCover == null || compe_i.DelvCover == '') {
              if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                this.items.push({
                  ...compe_i,
                  id: compe_i.DelvNo,
                  name: compe_i.DelvDes,
                  DelvLevel: '0',
                  NeedsCredit: '0',
                  ExpectCredit: '0',
                  children: []
                })
              } else {
                this.items.push({
                  ...compe_i,
                  id: compe_i.DelvNo,
                  name: compe_i.DelvEng + '( ' + compe_i.DelvDes + ' )',
                  DelvLevel: '0',
                  NeedsCredit: '0',
                  ExpectCredit: '0',
                  children: []
                })
              }
            }
          })
          this.items.map((data_i, idx) => {
            if (data_i.children.length == 0) {
              this.Competency.map(compe_i => {
                if (data_i.DelvNo == compe_i.DelvCover) {
                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                    this.items[idx].children.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes,
                      DelvLevel: '1',
                      NeedsCredit: '0',
                      ExpectCredit: '0',
                      children: []
                    })
                  } else {
                    this.items[idx].children.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvEng + '( ' + compe_i.DelvDes + ' )',
                      DelvLevel: '1',
                      NeedsCredit: '0',
                      ExpectCredit: '0',
                      children: []
                    })
                  }
                }
              })
            }
          })
          // lv2
          this.items.map(data_i => {
            if (data_i.children.length > 0) {
              data_i.children.map((child1_i, idx) => {
                if (child1_i.children.length == 0) {
                  this.Competency.map(compe_i => {
                    if (child1_i.DelvNo == compe_i.DelvCover) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        data_i.children[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '2',
                          NeedsCredit: '0',
                          ExpectCredit: '0',
                          children: []
                        })
                      } else {
                        data_i.children[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvEng + '( ' + compe_i.DelvDes + ' )',
                          DelvLevel: '2',
                          NeedsCredit: '0',
                          ExpectCredit: '0',
                          children: []
                        })
                      }

                    }
                  })
                }
              })
            }
          })

          // item to autocomplete
          this.items.map(itemRoot => {
            this.itemsSel.push({
              ...itemRoot
            })
            if (itemRoot.children.length > 0) {
              itemRoot.children.map(itemChild1 => {
                this.itemsSel.push({
                  ...itemChild1
                })
                if (itemChild1.children.length > 0) {
                  itemChild1.children.map(itemChild2 => {
                    this.itemsSel.push({
                      ...itemChild2
                    })
                  })
                }
              })
            }
          })
        }
      })
    },
    toggle_SelectAll(row) {
      var headerAxios = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      var headerAxiosDel = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'DELETE'
        }
      }
      this.CheckPermissFunc('3001').then(resPermiss => {
        if (resPermiss) {
          if (row.value) {
            if (this.TypePosition_M == 'G' || this.TypePosition_M == 'D') {
              axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Course_Delv/C_workExp_id/' + this.SelWorkAge, '', {
                headers: {
                  'Content-Type': 'application/json',
                }
              }).then(res => {
                if (res.data) {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Course_Delv/C_workExp_id/' + this.SelWorkAge, '', headerAxiosDel).then(res => {
                    if (res.data.status) {
                      row.items.map(item => {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Course_Delv', {
                          Course_code: item.Course_code,
                          C_workExp_id: this.SelWorkAge,
                          Create_By: this.MeData[0].perid
                        }, headerAxios)
                      })
                    }
                  })
                } else {
                  row.items.map(item => {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Course_Delv', {
                      Course_code: item.Course_code,
                      C_workExp_id: this.SelWorkAge,
                      Create_By: this.MeData[0].perid
                    }, headerAxios)
                  })
                }
              })
            } else {
              axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Course_Delv/supervisor_type_id/' + this.position_c, '', {
                headers: {
                  'Content-Type': 'application/json',
                }
              }).then(res => {
                if (res.data) {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Course_Delv/supervisor_type_id/' + this.position_c, '', headerAxiosDel).then(res => {
                    if (res.data.status) {
                      row.items.map(item => {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Course_Delv', {
                          Course_code: item.Course_code,
                          supervisor_type_id: this.position_c,
                          Create_By: this.MeData[0].perid
                        }, headerAxios)
                      })
                    }
                  })
                } else {
                  row.items.map(item => {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Course_Delv', {
                      Course_code: item.Course_code,
                      supervisor_type_id: this.position_c,
                      Create_By: this.MeData[0].perid
                    }, headerAxios)
                  })
                }
              })
            }
          } else {
            if (this.TypePosition_M == 'G' || this.TypePosition_M == 'D') {
              axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Course_Delv/C_workExp_id/' + this.SelWorkAge, '', {
                headers: {
                  'Content-Type': 'application/json',
                }
              }).then(res => {
                if (res.data) {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Course_Delv/C_workExp_id/' + this.SelWorkAge, '', headerAxiosDel).then(res => {
                    if (!res.data.status) {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'พบข้อผิดพลาด ไม่สามารถทำรายการได้ โปรดลองอีกครั้ง'
                      })
                    }
                  })
                }
              })
            } else {
              axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Course_Delv/supervisor_type_id/' + this.position_c, '', {
                headers: {
                  'Content-Type': 'application/json',
                }
              }).then(res => {
                if (res.data) {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Course_Delv/supervisor_type_id/' + this.position_c, '', headerAxiosDel).then(res => {
                    if (!res.data.status) {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'พบข้อผิดพลาด ไม่สามารถทำรายการได้ โปรดลองอีกครั้ง'
                      })
                    }
                  })
                }
              })
            }
          }
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    SaveSelToDb(row) {
      var headerAxios = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      var headerAxiosDel = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'DELETE'
        }
      }
      this.CheckPermissFunc('3001').then(resPermiss => {
        if (resPermiss) {
          if (row.value) {
            if (this.TypePosition_M == 'G' || this.TypePosition_M == 'D') {
              axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Course_Delv/C_workExp_id/' + this.SelWorkAge + '/Course_code/' + row.item.Course_code, '', {
                headers: {
                  'Content-Type': 'application/json',
                }
              }).then(res => {
                if (!res.data) {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Course_Delv', {
                    Course_code: row.item.Course_code,
                    C_workExp_id: this.SelWorkAge,
                    Create_By: this.MeData[0].perid
                  }, headerAxios).then(res => {
                    if (!res.data.status) {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'พบข้อผิดพลาด ไม่สามารถทำรายการได้ โปรดลองอีกครั้ง'
                      })
                    }
                  })
                }
              })
            } else {
              axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Course_Delv/supervisor_type_id/' + this.position_c + '/Course_code/' + row.item.Course_code, '', {
                headers: {
                  'Content-Type': 'application/json',
                }
              }).then(res => {
                if (!res.data) {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Course_Delv', {
                    Course_code: row.item.Course_code,
                    supervisor_type_id: this.position_c,
                    Create_By: this.MeData[0].perid
                  }, headerAxios).then(res => {
                    if (!res.data.status) {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'พบข้อผิดพลาด ไม่สามารถทำรายการได้ โปรดลองอีกครั้ง'
                      })
                    }
                  })
                }
              })
            }
          } else {
            if (this.TypePosition_M == 'G' || this.TypePosition_M == 'D') {
              axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Course_Delv/C_workExp_id/' + this.SelWorkAge + '/Course_code/' + row.item.Course_code, '', {
                headers: {
                  'Content-Type': 'application/json',
                }
              }).then(res => {
                if (res.data) {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Course_Delv/C_workExp_id/' + this.SelWorkAge + '/Course_code/' + row.item.Course_code, '', headerAxiosDel).then(res => {
                    if (!res.data.status) {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'พบข้อผิดพลาด ไม่สามารถทำรายการได้ โปรดลองอีกครั้ง'
                      })
                    }
                  })
                }
              })
            } else {
              //// here
              axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Course_Delv/supervisor_type_id/' + this.position_c + '/Course_code/' + row.item.Course_code, '', {
                headers: {
                  'Content-Type': 'application/json',
                }
              }).then(res => {
                if (res.data) {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Course_Delv/supervisor_type_id/' + this.position_c + '/Course_code/' + row.item.Course_code, '', headerAxiosDel).then(res => {
                    if (!res.data.status) {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'พบข้อผิดพลาด ไม่สามารถทำรายการได้ โปรดลองอีกครั้ง'
                      })
                    }
                  })
                }
              })
            }
          }
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    ChooseWorkAgeToCourse() {
      this.selectedCourse = []
      if (this.TypePosition_M == 'G' || this.TypePosition_M == 'D') {
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Course_Delv_view/C_workExp_id/' + this.SelWorkAge).then(res => {
          if (res.data) {
            if (res.data.length > 0) {
              res.data.map(item => {
                this.selectedCourse.push(item)
              })
            } else {
              this.selectedCourse.push(res.data)
            }
          } else {
            this.selectedCourse = []
          }
        })
      } else {
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Course_Delv_view/supervisor_type_id/' + this.position_c).then(res => {
          if (res.data) {
            if (res.data.length > 0) {
              res.data.map(item => {
                this.selectedCourse.push(item)
              })
            } else {
              this.selectedCourse.push(res.data)
            }
          } else {
            this.selectedCourse = []
          }
        })
      }
    },
    CheckPermissFunc(permiss) {
      var CheckPermiss = false
      return new Promise(resolve => {
        if (this.PermissionAdmin.length > 0) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == permiss) {
              CheckPermiss = true
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
                resolve(false)
              }
            }
          })
        } else {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == permiss) {
              CheckPermiss = true
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.Permission.length - 1) {
                resolve(false)
              }
            }
          })
        }
      })
    },
    ChangeTypePosition() {
      this.AgeName_M = ''
      this.AgeDesc_M = ''
      this.AgeStart_M = ''
      this.AgeEnd_M = ''
      this.FixDep = ''
      this.selection = []
      this.selectedCourse = []
    },
    DeleteCompetency(item) {
      var DelCompe = false
      if (this.PermissionAdmin.length > 0) {
        this.PermissionAdmin.map((Per_i, idx) => {
          if (Per_i.permission_id == '3001') {
            DelCompe = true

            this.CompetencyToDel = item
            this.dialogDeleteCompetency = true
          } else {
            if (!DelCompe && idx == this.PermissionAdmin.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      } else {
        this.Permission.map((Per_i, idx) => {
          if (Per_i.permission_id == '3001') {
            DelCompe = true

            this.CompetencyToDel = item
            this.dialogDeleteCompetency = true
          } else {
            if (!DelCompe && idx == this.Permission.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      }

    },
    DeleteCompetencyConfirm() {
      this.dialogDeleteCompetency = false
      var headerAxios = {
        headers: {
          'X-REST-METHOD': 'DELETE'
        }
      }
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_workExp/id/' + this.CompetencyToDel.id, '', headerAxios).then(res => {
        if (res.data) {
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_PositionDelv/PosNew/' + this.CompetencyToDel.PosNew + '/WorkExp/' + this.CompetencyToDel.WorkExp, '', headerAxios).then(res => {
            if (res.data) {
              this.$swal.fire({
                icon: 'success',
                title: 'บันทึกข้อมูลสำเร็จ'
              })
              this.GetPositionToShow()
              this.ChooseAgeData = ''
              this.selection = []
            } else {
              this.$swal.fire({
                icon: 'success',
                title: 'บันทึกข้อมูลสำเร็จ'
              })
              this.GetPositionToShow()
              this.ChooseAgeData = ''
              this.selection = []
            }
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่สามารถลบข้อมูลได้สำเร็จ'
          })
          this.GetPositionToShow()
          this.ChooseAgeData = ''
          this.selection = []
        }
      })
    },
    selectionFunc() {
      this.selection = []
      this.competencySelection = []
      var urlConnection = ''
      var PostType = []
      this.clearCredit() // ล้างข้อมูล เครดิต
      if (this.TypePosition_M == 'G' || this.TypePosition_M == 'D') {
        PostType = this.WorkAgeData.filter(work_i => work_i.id == this.ChooseAgeData)
        urlConnection = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_PositionDelv_view/PosNew/' + this.position_c + '/WorkExp/' + PostType[0].WorkExp
      } else {
        urlConnection = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_PositionDelv_view/supervisor_type_id/' + this.position_c
      }
      return new Promise(resolve => {
        axios.get(urlConnection).then(res => {
          if (res.data) {
            if (res.data.length > 0) {
              // this.competencySelection = res.data
              res.data.map(res_i => {
                this.selection.push(res_i.DelvNo)
                resolve(true)
              })

              res.data.map(res_i => {
                this.items.map(compe_i => {
                  if (res_i.DelvNo == compe_i.DelvNo) {
                    compe_i.ExpectCredit = res_i.ExpectCredit
                    compe_i.NeedsCredit = res_i.NeedsCredit
                  }
                  if (compe_i.children.length > 0) {
                    compe_i.children.map(Child_1 => {
                      if (res_i.DelvNo == Child_1.DelvNo) {
                        Child_1.ExpectCredit = res_i.ExpectCredit
                        Child_1.NeedsCredit = res_i.NeedsCredit
                      }
                      if (Child_1.children.length > 0) {
                        Child_1.children.map(Child_2 => {
                          if (res_i.DelvNo == Child_2.DelvNo) {
                            Child_2.ExpectCredit = res_i.ExpectCredit
                            Child_2.NeedsCredit = res_i.NeedsCredit
                          }
                        })
                      }
                    })
                  }
                })
              })
            } else {
              // this.competencySelection.push(res.data)
              this.selection.push(res.data.DelvNo)

              this.items.map(compe_i => {
                if (res.data.DelvNo == compe_i.DelvNo) {
                  compe_i.ExpectCredit = res.data.ExpectCredit
                  compe_i.NeedsCredit = res.data.NeedsCredit
                }
                if (compe_i.children.length > 0) {
                  compe_i.children.map(Child_1 => {
                    if (res.data.DelvNo == Child_1.DelvNo) {
                      Child_1.ExpectCredit = res.data.ExpectCredit
                      Child_1.NeedsCredit = res.data.NeedsCredit
                    }
                    if (Child_1.children.length > 0) {
                      Child_1.children.map(Child_2 => {
                        if (res.data.DelvNo == Child_2.DelvNo) {
                          Child_2.ExpectCredit = res.data.ExpectCredit
                          Child_2.NeedsCredit = res.data.NeedsCredit
                        }
                      })
                    }
                  })
                }
              })

              resolve(true)
            }
          } else {
            this.selection = []
            this.competencySelection = []
            resolve(false)
          }
        })
      })
    },
    clearCredit() {
      if (this.items.length > 0) {
        this.items.map(compe_i => {
          compe_i.ExpectCredit = 0
          compe_i.NeedsCredit = 0
          if (compe_i.children.length > 0) {
            compe_i.children.map(Child_1 => {
              Child_1.ExpectCredit = 0
              Child_1.NeedsCredit = 0
              if (Child_1.children.length > 0) {
                Child_1.children.map(Child_2 => {
                  Child_2.ExpectCredit = 0
                  Child_2.NeedsCredit = 0
                })
              }
            })
          }
        })
      }
    },
    showCourse(item){
      this.CourseToShow = []
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_Course_Delv_view/C_workExp_id/' + item.id).then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.CourseToShow.push({
                ...item,
                full_Detail: '<div><span style="font-weight: bold;color: #364eff">' + item.Course_name + '</span></div>' +
                    '<div><span style="font-weight: bold;color: darkslategrey">' + item.dep_name + '</span></div>',
                statusReg: false
              })
            })
          } else {
            this.CourseToShow.push({
              ...item,
              full_Detail: '<div><span style="font-weight: bold;color: #364eff">' + res.data.Course_name + '</span></div>' +
                  '<div><span style="font-weight: bold;color: darkslategrey">' + res.data.dep_name + '</span></div>',
              statusReg: false
            })
          }
        } else {
          this.CourseToShow = []
        }
      })
    },
    showCompetency(item) {
      this.CompetencyToShow = []
      var urlConnection = ''
      if (this.TypePosition_M == 'G' || this.TypePosition_M == 'D') {
        urlConnection = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_PositionDelv_view/PosNew/' + item.PosNew + '/WorkExp/' + item.WorkExp
      } else {
        urlConnection = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_PositionDelv_view/supervisor_type_id/' + this.position_c
      }
      axios.get(urlConnection).then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(posi_i => {
              this.Competency.map(compe_i => {
                if (posi_i.DelvCover == compe_i.DelvNo) {
                  if (compe_i.DelvCover != null && compe_i.DelvCover != '') {
                    this.Competency.map(compe_i2 => {
                      if (compe_i.DelvCover == compe_i2.DelvNo) {
                        var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i2.DelvNo)

                        if (CheckCompetency.length == 0) {
                          if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes,
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvEng + '( ' + compe_i2.DelvDes + ' )',
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      }
                    })

                    // lv1
                    if (this.CompetencyToShow.length > 0) {
                      this.CompetencyToShow.map(ComToShow => {
                        if (ComToShow.children.length > 0) {
                          ComToShow.children.map((ComToShow_c, idx_to_Show) => {
                            CheckCompetency = false
                            if (compe_i.DelvNo == ComToShow_c.DelvNo) {
                              CheckCompetency = true
                            }
                            if (!CheckCompetency && idx_to_Show == ComToShow.children.length - 1) {
                              this.CompetencyToShow.map((data_i, idx) => {
                                if (data_i.DelvNo == compe_i.DelvCover) {
                                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes,
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  } else {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvEng + '( ' + compe_i.DelvDes + ' )',
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  }
                                }
                              })
                            }
                          })
                        } else {
                          this.CompetencyToShow.map((data_i, idx) => {
                            if (data_i.DelvNo == compe_i.DelvCover) {
                              if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes,
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              } else {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvEng + '( ' + compe_i.DelvDes + ' )',
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              }
                            }
                          })
                        }
                      })
                    }

                    //lv2
                    this.CompetencyToShow.map((data_i, idx) => {
                      data_i.children.map((child_i, c_idx) => {
                        if (child_i.DelvNo == posi_i.DelvCover) {
                          if (posi_i.DelvEng == null || posi_i.DelvEng == '') {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes,
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes + '( ' + posi_i.DelvEng + ' )',
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      })
                    })
                  } else {
                    var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i.DelvNo)

                    if (CheckCompetency.length == 0) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvEng + '( ' + compe_i.DelvDes + ' )',
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      }
                    }

                    this.Competency.map(compe_i2 => {
                      if (posi_i.DelvNo == compe_i2.DelvNo) {
                        this.CompetencyToShow.map((data_i, idx) => {
                          if (data_i.DelvNo == posi_i.DelvCover) {
                            if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes,
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            } else {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvEng + '( ' + compe_i2.DelvDes + ' )',
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            }
                          }
                        })
                      }
                    })
                  }
                }
              })
            })
          } else {
            // root
            this.Competency.map(compe_i => {
              if (res.data.DelvCover == compe_i.DelvNo) {
                if (compe_i.DelvCover != null && compe_i.DelvCover != '') {
                  this.Competency.map(compe_i2 => {
                    if (compe_i.DelvCover == compe_i2.DelvNo) {
                      if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                        this.CompetencyToShow.push({
                          ...compe_i2,
                          id: compe_i2.DelvNo,
                          name: compe_i2.DelvDes,
                          DelvLevel: '0',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow.push({
                          ...compe_i2,
                          id: compe_i2.DelvNo,
                          name: compe_i2.DelvEng + '( ' + compe_i2.DelvDes + ' )',
                          DelvLevel: '0',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      }
                    }
                  })

                  // lv1
                  this.CompetencyToShow.map((data_i, idx) => {
                    if (data_i.DelvNo == compe_i.DelvCover) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        this.CompetencyToShow[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '1',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvEng + '( ' + compe_i.DelvDes + ' )',
                          DelvLevel: '1',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      }
                    }
                  })

                  //lv2
                  this.CompetencyToShow.map((data_i, idx) => {
                    data_i.children.map((child_i, c_idx) => {
                      if (child_i.DelvNo == res.data.DelvCover) {
                        if (res.data.DelvEng == null || res.data.DelvEng == '') {
                          this.CompetencyToShow[idx].children[c_idx].children.push({
                            ...res.data,
                            id: res.data.DelvNo,
                            name: res.data.DelvDes,
                            DelvLevel: '2',
                            NeedsCredit: res.data.NeedsCredit,
                            ExpectCredit: res.data.ExpectCredit,
                            children: []
                          })
                        } else {
                          this.CompetencyToShow[idx].children[c_idx].children.push({
                            ...res.data,
                            id: res.data.DelvNo,
                            name: res.data.DelvEng + '( ' + res.data.DelvDes + ' )',
                            DelvLevel: '2',
                            NeedsCredit: res.data.NeedsCredit,
                            ExpectCredit: res.data.ExpectCredit,
                            children: []
                          })
                        }
                      }
                    })
                  })
                } else {
                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                    this.CompetencyToShow.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes,
                      DelvLevel: '0',
                      NeedsCredit: res.data.NeedsCredit,
                      ExpectCredit: res.data.ExpectCredit,
                      children: []
                    })
                  } else {
                    this.CompetencyToShow.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvEng + '( ' + compe_i.DelvDes + ' )',
                      DelvLevel: '0',
                      NeedsCredit: res.data.NeedsCredit,
                      ExpectCredit: res.data.ExpectCredit,
                      children: []
                    })
                  }

                  this.Competency.map(compe_i2 => {
                    if (res.data.DelvNo == compe_i2.DelvNo) {
                      this.CompetencyToShow.map((data_i, idx) => {
                        if (data_i.DelvNo == res.data.DelvCover) {
                          if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                            this.CompetencyToShow[idx].children.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes,
                              DelvLevel: '1',
                              NeedsCredit: res.data.NeedsCredit,
                              ExpectCredit: res.data.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow[idx].children.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvEng + '( ' + compe_i2.DelvDes + ' )',
                              DelvLevel: '1',
                              NeedsCredit: res.data.NeedsCredit,
                              ExpectCredit: res.data.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      })
                    }
                  })
                }
              }
            })
          }
          this.dialogCompetency = true
        } else {
          this.dialogCompetency = false
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่พบข้อมูล Competency'
          })
        }
      })
    },
    AddCompetency() {
      var CheckCompe = false
      if (this.PermissionAdmin.length > 0) {
        this.PermissionAdmin.map((Per_i, idx) => {
          if (Per_i.permission_id == '3001') {
            CheckCompe = true

            this.selectionToDb = []
            var CheckDataToDb = false
            var CheckDataToDb2 = false
            var headerAxios = {
              headers: {
                'X-REST-METHOD': 'PUT'
              }
            }

            if (this.TypePosition_M == 'G' || this.TypePosition_M == 'D') {
              if (this.ChooseAgeData != '' || this.posi_choose != '') {

                if (this.selection.length > 0) {
                  var PostType = this.WorkAgeData.filter(work_i => work_i.id == this.ChooseAgeData)
                  for (var i = 0; i <= this.selection.length - 1; i++) {
                    this.items.map(root => {
                      if (root.children.length > 0) {
                        root.children.map(child1 => {
                          if (child1.children.length > 0) {
                            child1.children.map(child2 => {
                              if (child2.id == this.selection[i]) {
                                this.selectionToDb.push(
                                    {
                                      PostType: PostType[0].PostType,
                                      PosNew: this.position_c,
                                      WorkExp: PostType[0].WorkExp,
                                      DelvNo: child2.DelvNo,
                                      NeedsCredit: child2.NeedsCredit,
                                      ExpectCredit: child2.ExpectCredit,
                                      Rm: '',
                                    }
                                )
                              }
                            })
                          }
                          if (child1.id == this.selection[i]) {
                            this.selectionToDb.push(
                                {
                                  PostType: PostType[0].PostType,
                                  PosNew: this.position_c,
                                  WorkExp: PostType[0].WorkExp,
                                  DelvNo: child1.DelvNo,
                                  NeedsCredit: child1.NeedsCredit,
                                  ExpectCredit: child1.ExpectCredit,
                                  Rm: '',
                                }
                            )
                          }
                        })
                      }
                      if (root.id == this.selection[i]) {
                        this.selectionToDb.push(
                            {
                              PostType: PostType[0].PostType,
                              PosNew: this.position_c,
                              WorkExp: PostType[0].WorkExp,
                              DelvNo: root.DelvNo,
                              NeedsCredit: root.NeedsCredit,
                              ExpectCredit: root.ExpectCredit,
                              Rm: '',
                            }
                        )
                      }
                    })
                  }

                  this.selectionToDb.map((sel_i, idx) => {
                    CheckDataToDb = false
                    if (this.competencySelection.length > 0) {
                      this.competencySelection.map((compeSel, idx_CompSel) => {
                        CheckDataToDb2 = false
                        if (compeSel.DelvNo == sel_i.DelvNo) {
                          CheckDataToDb = true
                        } else {
                          this.selectionToDb.map((sel_i2, idx_sel) => {
                            if (sel_i2.DelvNo == compeSel.DelvNo) {
                              CheckDataToDb2 = true
                            }

                            if (!CheckDataToDb2 && idx_sel == this.selectionToDb.length - 1) {
                              headerAxios = {
                                headers: {
                                  'X-REST-METHOD': 'DELETE'
                                }
                              }
                              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_PositionDelv/DelvNo/' + compeSel.DelvNo, '', headerAxios).then(res => {
                                if (idx == this.selectionToDb.length - 1) {
                                  if (res.data.status) {
                                    this.$swal.fire({
                                      icon: 'success',
                                      title: 'บันทึกข้อมูลสำเร็จ'
                                    })
                                    this.selectionFunc()
                                  }
                                }
                              })
                            }
                          })
                        }
                        if (!CheckDataToDb && idx_CompSel == this.competencySelection.length - 1) {
                          headerAxios = {
                            headers: {
                              'X-REST-METHOD': 'PUT'
                            }
                          }
                          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_PositionDelv', {
                            PostType: sel_i.PostType,
                            PosNew: sel_i.PosNew,
                            WorkExp: sel_i.WorkExp,
                            DelvNo: sel_i.DelvNo,
                            NeedsCredit: sel_i.NeedsCredit,
                            ExpectCredit: sel_i.ExpectCredit,
                            Rm: '',
                          }, headerAxios).then(res => {
                            if (idx == this.selectionToDb.length - 1) {
                              if (res.data.status) {
                                this.$swal.fire({
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลสำเร็จ'
                                })
                                this.selectionFunc()
                              }
                            }
                          })
                        }
                      })
                    } else {
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_PositionDelv', {
                        PostType: sel_i.PostType,
                        PosNew: sel_i.PosNew,
                        WorkExp: sel_i.WorkExp,
                        DelvNo: sel_i.DelvNo,
                        NeedsCredit: sel_i.NeedsCredit,
                        ExpectCredit: sel_i.ExpectCredit,
                        Rm: '',
                      }, headerAxios).then(res => {
                        if (idx == this.selectionToDb.length - 1) {
                          if (res.data.status) {
                            this.$swal.fire({
                              icon: 'success',
                              title: 'บันทึกข้อมูลสำเร็จ'
                            })
                            this.selectionFunc()
                          }
                        }
                      })
                    }
                  })
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'กรุณาเลือก Competency'
                  })
                }

              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'กรุณาระบุข้อมูลตำแหน่งและช่วงอายุงานให้ครบถ้วน'
                })
              }
            } else if (this.TypePosition_M == 'M') {
              if (this.selection.length > 0) {
                for (i = 0; i <= this.selection.length - 1; i++) {
                  this.items.map(root => {
                    if (root.children.length > 0) {
                      root.children.map(child1 => {
                        if (child1.children.length > 0) {
                          child1.children.map(child2 => {
                            if (child2.id == this.selection[i]) {
                              this.selectionToDb.push(
                                  {
                                    PostType: this.TypePosition_M,
                                    PosNew: null,
                                    WorkExp: null,
                                    supervisor_type_id: this.position_c,
                                    DelvNo: child2.DelvNo,
                                    NeedsCredit: child2.NeedsCredit,
                                    ExpectCredit: child2.ExpectCredit,
                                    Rm: '',
                                  }
                              )
                            }
                          })
                        }
                        if (child1.id == this.selection[i]) {
                          this.selectionToDb.push(
                              {
                                PostType: this.TypePosition_M,
                                PosNew: null,
                                WorkExp: null,
                                supervisor_type_id: this.position_c,
                                DelvNo: child1.DelvNo,
                                NeedsCredit: child1.NeedsCredit,
                                ExpectCredit: child1.ExpectCredit,
                                Rm: '',
                              }
                          )
                        }
                      })
                    }
                    if (root.id == this.selection[i]) {
                      this.selectionToDb.push(
                          {
                            PostType: this.TypePosition_M,
                            PosNew: null,
                            WorkExp: null,
                            supervisor_type_id: this.position_c,
                            DelvNo: root.DelvNo,
                            NeedsCredit: root.NeedsCredit,
                            ExpectCredit: root.ExpectCredit,
                            Rm: '',
                          }
                      )
                    }
                  })
                }

                this.selectionToDb.map((sel_i, idx) => {
                  CheckDataToDb = false
                  if (this.competencySelection.length > 0) {
                    this.competencySelection.map((compeSel, idx_CompSel) => {
                      CheckDataToDb2 = false
                      if (compeSel.DelvNo == sel_i.DelvNo) {
                        CheckDataToDb = true
                      } else {
                        this.selectionToDb.map((sel_i2, idx_sel) => {
                          if (sel_i2.DelvNo == compeSel.DelvNo) {
                            CheckDataToDb2 = true
                          }

                          if (!CheckDataToDb2 && idx_sel == this.selectionToDb.length - 1) {
                            headerAxios = {
                              headers: {
                                'X-REST-METHOD': 'DELETE'
                              }
                            }
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_PositionDelv/DelvNo/' + compeSel.DelvNo, '', headerAxios).then(res => {
                              if (idx == this.selectionToDb.length - 1) {
                                if (res.data.status) {
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลสำเร็จ'
                                  })
                                  this.selectionFunc()
                                }
                              }
                            })
                          }
                        })
                      }
                      if (!CheckDataToDb && idx_CompSel == this.competencySelection.length - 1) {
                        headerAxios = {
                          headers: {
                            'X-REST-METHOD': 'PUT'
                          }
                        }
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_PositionDelv', {
                          PostType: sel_i.PostType,
                          PosNew: sel_i.PosNew,
                          WorkExp: sel_i.WorkExp,
                          DelvNo: sel_i.DelvNo,
                          NeedsCredit: sel_i.NeedsCredit,
                          ExpectCredit: sel_i.ExpectCredit,
                          supervisor_type_id: sel_i.supervisor_type_id,
                          Rm: '',
                        }, headerAxios).then(res => {
                          if (idx == this.selectionToDb.length - 1) {
                            if (res.data.status) {
                              this.$swal.fire({
                                icon: 'success',
                                title: 'บันทึกข้อมูลสำเร็จ'
                              })
                              this.selectionFunc()
                            }
                          }
                        })
                      }
                    })
                  } else {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_PositionDelv', {
                      PostType: sel_i.PostType,
                      PosNew: sel_i.PosNew,
                      WorkExp: sel_i.WorkExp,
                      DelvNo: sel_i.DelvNo,
                      NeedsCredit: sel_i.NeedsCredit,
                      ExpectCredit: sel_i.ExpectCredit,
                      supervisor_type_id: sel_i.supervisor_type_id,
                      Rm: '',
                    }, headerAxios).then(res => {
                      if (idx == this.selectionToDb.length - 1) {
                        if (res.data.status) {
                          this.$swal.fire({
                            icon: 'success',
                            title: 'บันทึกข้อมูลสำเร็จ'
                          })
                          this.selectionFunc()
                        }
                      }
                    })
                  }
                })
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'กรุณาเลือก Competency'
                })
              }
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'กรุณาเลือกประเภทตำแหน่ง'
              })
            }
          } else {
            if (!CheckCompe && idx == this.PermissionAdmin.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      } else {
        this.Permission.map((Per_i, idx) => {
          if (Per_i.permission_id == '3001') {
            CheckCompe = true

            this.selectionToDb = []
            var CheckDataToDb = false
            var CheckDataToDb2 = false
            var headerAxios = {
              headers: {
                'X-REST-METHOD': 'PUT'
              }
            }

            if (this.TypePosition_M == 'G' || this.TypePosition_M == 'D') {
              if (this.ChooseAgeData != '' || this.posi_choose != '') {

                if (this.selection.length > 0) {
                  var PostType = this.WorkAgeData.filter(work_i => work_i.id == this.ChooseAgeData)
                  for (var i = 0; i <= this.selection.length - 1; i++) {
                    this.items.map(root => {
                      if (root.children.length > 0) {
                        root.children.map(child1 => {
                          if (child1.children.length > 0) {
                            child1.children.map(child2 => {
                              if (child2.id == this.selection[i]) {
                                this.selectionToDb.push(
                                    {
                                      PostType: PostType[0].PostType,
                                      PosNew: this.position_c,
                                      WorkExp: PostType[0].WorkExp,
                                      DelvNo: child2.DelvNo,
                                      NeedsCredit: child2.NeedsCredit,
                                      ExpectCredit: child2.ExpectCredit,
                                      Rm: '',
                                    }
                                )
                              }
                            })
                          }
                          if (child1.id == this.selection[i]) {
                            this.selectionToDb.push(
                                {
                                  PostType: PostType[0].PostType,
                                  PosNew: this.position_c,
                                  WorkExp: PostType[0].WorkExp,
                                  DelvNo: child1.DelvNo,
                                  NeedsCredit: child1.NeedsCredit,
                                  ExpectCredit: child1.ExpectCredit,
                                  Rm: '',
                                }
                            )
                          }
                        })
                      }
                      if (root.id == this.selection[i]) {
                        this.selectionToDb.push(
                            {
                              PostType: PostType[0].PostType,
                              PosNew: this.position_c,
                              WorkExp: PostType[0].WorkExp,
                              DelvNo: root.DelvNo,
                              NeedsCredit: root.NeedsCredit,
                              ExpectCredit: root.ExpectCredit,
                              Rm: '',
                            }
                        )
                      }
                    })
                  }

                  this.selectionToDb.map((sel_i, idx) => {
                    CheckDataToDb = false
                    if (this.competencySelection.length > 0) {
                      this.competencySelection.map((compeSel, idx_CompSel) => {
                        CheckDataToDb2 = false
                        if (compeSel.DelvNo == sel_i.DelvNo) {
                          CheckDataToDb = true
                        } else {
                          this.selectionToDb.map((sel_i2, idx_sel) => {
                            if (sel_i2.DelvNo == compeSel.DelvNo) {
                              CheckDataToDb2 = true
                            }

                            if (!CheckDataToDb2 && idx_sel == this.selectionToDb.length - 1) {
                              headerAxios = {
                                headers: {
                                  'X-REST-METHOD': 'DELETE'
                                }
                              }
                              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_PositionDelv/DelvNo/' + compeSel.DelvNo, '', headerAxios).then(res => {
                                if (idx == this.selectionToDb.length - 1) {
                                  if (res.data.status) {
                                    this.$swal.fire({
                                      icon: 'success',
                                      title: 'บันทึกข้อมูลสำเร็จ'
                                    })
                                    this.selectionFunc()
                                  }
                                }
                              })
                            }
                          })
                        }
                        if (!CheckDataToDb && idx_CompSel == this.competencySelection.length - 1) {
                          headerAxios = {
                            headers: {
                              'X-REST-METHOD': 'PUT'
                            }
                          }
                          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_PositionDelv', {
                            PostType: sel_i.PostType,
                            PosNew: sel_i.PosNew,
                            WorkExp: sel_i.WorkExp,
                            DelvNo: sel_i.DelvNo,
                            NeedsCredit: sel_i.NeedsCredit,
                            ExpectCredit: sel_i.ExpectCredit,
                            Rm: '',
                          }, headerAxios).then(res => {
                            if (idx == this.selectionToDb.length - 1) {
                              if (res.data.status) {
                                this.$swal.fire({
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลสำเร็จ'
                                })
                                this.selectionFunc()
                              }
                            }
                          })
                        }
                      })
                    } else {
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_PositionDelv', {
                        PostType: sel_i.PostType,
                        PosNew: sel_i.PosNew,
                        WorkExp: sel_i.WorkExp,
                        DelvNo: sel_i.DelvNo,
                        NeedsCredit: sel_i.NeedsCredit,
                        ExpectCredit: sel_i.ExpectCredit,
                        Rm: '',
                      }, headerAxios).then(res => {
                        if (idx == this.selectionToDb.length - 1) {
                          if (res.data.status) {
                            this.$swal.fire({
                              icon: 'success',
                              title: 'บันทึกข้อมูลสำเร็จ'
                            })
                            this.selectionFunc()
                          }
                        }
                      })
                    }
                  })
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'กรุณาเลือก Competency'
                  })
                }

              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'กรุณาระบุข้อมูลตำแหน่งและช่วงอายุงานให้ครบถ้วน'
                })
              }
            } else if (this.TypePosition_M == 'M') {
              if (this.selection.length > 0) {
                for (i = 0; i <= this.selection.length - 1; i++) {
                  this.items.map(root => {
                    if (root.children.length > 0) {
                      root.children.map(child1 => {
                        if (child1.children.length > 0) {
                          child1.children.map(child2 => {
                            if (child2.id == this.selection[i]) {
                              this.selectionToDb.push(
                                  {
                                    PostType: this.TypePosition_M,
                                    PosNew: null,
                                    WorkExp: null,
                                    supervisor_type_id: this.position_c,
                                    DelvNo: child2.DelvNo,
                                    NeedsCredit: child2.NeedsCredit,
                                    ExpectCredit: child2.ExpectCredit,
                                    Rm: '',
                                  }
                              )
                            }
                          })
                        }
                        if (child1.id == this.selection[i]) {
                          this.selectionToDb.push(
                              {
                                PostType: this.TypePosition_M,
                                PosNew: null,
                                WorkExp: null,
                                supervisor_type_id: this.position_c,
                                DelvNo: child1.DelvNo,
                                NeedsCredit: child1.NeedsCredit,
                                ExpectCredit: child1.ExpectCredit,
                                Rm: '',
                              }
                          )
                        }
                      })
                    }
                    if (root.id == this.selection[i]) {
                      this.selectionToDb.push(
                          {
                            PostType: this.TypePosition_M,
                            PosNew: null,
                            WorkExp: null,
                            supervisor_type_id: this.position_c,
                            DelvNo: root.DelvNo,
                            NeedsCredit: root.NeedsCredit,
                            ExpectCredit: root.ExpectCredit,
                            Rm: '',
                          }
                      )
                    }
                  })
                }

                this.selectionToDb.map((sel_i, idx) => {
                  CheckDataToDb = false
                  if (this.competencySelection.length > 0) {
                    this.competencySelection.map((compeSel, idx_CompSel) => {
                      CheckDataToDb2 = false
                      if (compeSel.DelvNo == sel_i.DelvNo) {
                        CheckDataToDb = true
                      } else {
                        this.selectionToDb.map((sel_i2, idx_sel) => {
                          if (sel_i2.DelvNo == compeSel.DelvNo) {
                            CheckDataToDb2 = true
                          }

                          if (!CheckDataToDb2 && idx_sel == this.selectionToDb.length - 1) {
                            headerAxios = {
                              headers: {
                                'X-REST-METHOD': 'DELETE'
                              }
                            }
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_PositionDelv/DelvNo/' + compeSel.DelvNo, '', headerAxios).then(res => {
                              if (idx == this.selectionToDb.length - 1) {
                                if (res.data.status) {
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลสำเร็จ'
                                  })
                                  this.selectionFunc()
                                }
                              }
                            })
                          }
                        })
                      }
                      if (!CheckDataToDb && idx_CompSel == this.competencySelection.length - 1) {
                        headerAxios = {
                          headers: {
                            'X-REST-METHOD': 'PUT'
                          }
                        }
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_PositionDelv', {
                          PostType: sel_i.PostType,
                          PosNew: sel_i.PosNew,
                          WorkExp: sel_i.WorkExp,
                          DelvNo: sel_i.DelvNo,
                          NeedsCredit: sel_i.NeedsCredit,
                          ExpectCredit: sel_i.ExpectCredit,
                          supervisor_type_id: sel_i.supervisor_type_id,
                          Rm: '',
                        }, headerAxios).then(res => {
                          if (idx == this.selectionToDb.length - 1) {
                            if (res.data.status) {
                              this.$swal.fire({
                                icon: 'success',
                                title: 'บันทึกข้อมูลสำเร็จ'
                              })
                              this.selectionFunc()
                            }
                          }
                        })
                      }
                    })
                  } else {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_PositionDelv', {
                      PostType: sel_i.PostType,
                      PosNew: sel_i.PosNew,
                      WorkExp: sel_i.WorkExp,
                      DelvNo: sel_i.DelvNo,
                      NeedsCredit: sel_i.NeedsCredit,
                      ExpectCredit: sel_i.ExpectCredit,
                      supervisor_type_id: sel_i.supervisor_type_id,
                      Rm: '',
                    }, headerAxios).then(res => {
                      if (idx == this.selectionToDb.length - 1) {
                        if (res.data.status) {
                          this.$swal.fire({
                            icon: 'success',
                            title: 'บันทึกข้อมูลสำเร็จ'
                          })
                          this.selectionFunc()
                        }
                      }
                    })
                  }
                })
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'กรุณาเลือก Competency'
                })
              }
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'กรุณาเลือกประเภทตำแหน่ง'
              })
            }
          } else {
            if (!CheckCompe && idx == this.Permission.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      }

    },
    ShowDetail(item) {
      this.dialogDetail = true
      this.itemToShow = null
      this.itemToShow = item
    },
    AddWorkAge() {
      // if (this.WorkAgeData.filter(item => parseInt(item.eExpYeay) < parseInt(this.AgeEnd_M))[0].length == 0 && parseInt(this.AgeEnd_M) >= 0) {
      //   console.log('here')
      //
      // } else {
      //   console.log('not')
      // }
      var CheckWorkAge = false
      if (this.PermissionAdmin.length > 0) {
        this.PermissionAdmin.map((Per_i, idx) => {
          if (Per_i.permission_id == '3001') {
            CheckWorkAge = true

            const headerAxios = {
              headers: {
                'X-REST-METHOD': 'PUT'
              }
            }
            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_workExp/PosNew/' + this.position_c + '/?sort=WorkExp_desc&limit=1').then(res => {
              if (res.data) {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_workExp', {
                  PostType: this.TypePosition_M,
                  PosNew: this.position_c,
                  WorkExp: parseInt(res.data.WorkExp) + 1,
                  WorkExpName: this.AgeName_M,
                  WorkExpDes: this.AgeDesc_M,
                  sExpYeay: this.AgeStart_M,
                  eExpYeay: this.AgeEnd_M,
                  Dep_Code: this.FixDep,
                  WorkExpStatus: '1',
                }, headerAxios).then(res => {
                  if (res.data.status) {
                    this.$swal.fire({
                      icon: 'success',
                      title: 'บันทึกข้อมูลสำเร็จ'
                    })
                    this.GetPositionToShow()
                    this.AgeName_M = ''
                    this.AgeDesc_M = ''
                    this.AgeStart_M = ''
                    this.AgeEnd_M = ''
                    this.FixDep = ''
                  }
                })
              } else {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_workExp', {
                  PostType: this.TypePosition_M,
                  PosNew: this.position_c,
                  WorkExp: '1000',
                  WorkExpName: this.AgeName_M,
                  WorkExpDes: this.AgeDesc_M,
                  sExpYeay: this.AgeStart_M,
                  eExpYeay: this.AgeEnd_M,
                  Dep_Code: this.FixDep,
                  WorkExpStatus: '1',
                }, headerAxios).then(res => {
                  if (res.data.status) {
                    this.$swal.fire({
                      icon: 'success',
                      title: 'บันทึกข้อมูลสำเร็จ'
                    })
                    this.GetPositionToShow()
                    this.AgeName_M = ''
                    this.AgeDesc_M = ''
                    this.AgeStart_M = ''
                    this.AgeEnd_M = ''
                    this.FixDep = ''
                  }
                })
              }
            })
          } else {
            if (!CheckWorkAge && idx == this.PermissionAdmin.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      } else {
        this.Permission.map((Per_i, idx) => {
          if (Per_i.permission_id == '3001') {
            CheckWorkAge = true

            const headerAxios = {
              headers: {
                'X-REST-METHOD': 'PUT'
              }
            }
            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_workExp/PosNew/' + this.position_c + '/?sort=WorkExp_desc&limit=1').then(res => {
              if (res.data) {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_workExp', {
                  PostType: this.TypePosition_M,
                  PosNew: this.position_c,
                  WorkExp: parseInt(res.data.WorkExp) + 1,
                  WorkExpName: this.AgeName_M,
                  WorkExpDes: this.AgeDesc_M,
                  sExpYeay: this.AgeStart_M,
                  eExpYeay: this.AgeEnd_M,
                  Dep_Code: this.FixDep,
                  WorkExpStatus: '1',
                }, headerAxios).then(res => {
                  if (res.data.status) {
                    this.$swal.fire({
                      icon: 'success',
                      title: 'บันทึกข้อมูลสำเร็จ'
                    })
                    this.GetPositionToShow()
                    this.AgeName_M = ''
                    this.AgeDesc_M = ''
                    this.AgeStart_M = ''
                    this.AgeEnd_M = ''
                    this.FixDep = ''
                  }
                })
              } else {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_workExp', {
                  PostType: this.TypePosition_M,
                  PosNew: this.position_c,
                  WorkExp: '1000',
                  WorkExpName: this.AgeName_M,
                  WorkExpDes: this.AgeDesc_M,
                  sExpYeay: this.AgeStart_M,
                  eExpYeay: this.AgeEnd_M,
                  Dep_Code: this.FixDep,
                  WorkExpStatus: '1',
                }, headerAxios).then(res => {
                  if (res.data.status) {
                    this.$swal.fire({
                      icon: 'success',
                      title: 'บันทึกข้อมูลสำเร็จ'
                    })
                    this.GetPositionToShow()
                    this.AgeName_M = ''
                    this.AgeDesc_M = ''
                    this.AgeStart_M = ''
                    this.AgeEnd_M = ''
                    this.FixDep = ''
                  }
                })
              }
            })
          } else {
            if (!CheckWorkAge && idx == this.Permission.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      }

    },
    DeleteItem(dataPosition) {
      var CheckDelete = true
      var Count = 0
      const headerAxios = {
        headers: {
          'X-REST-METHOD': 'DELETE'
        }
      }
      if (dataPosition.children != null && dataPosition.children.length > 0) {
        dataPosition.children.map((item_age) => {
          if (item_age.children != null && item_age.children.length > 0) {
            item_age.children.map((item_course) => {
              if (CheckDelete) {
                const headerAxios = {
                  headers: {
                    'X-REST-METHOD': 'DELETE'
                  }
                }
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_position_cordi/Id/' + item_age.id, '', headerAxios).then(res => {
                  if (res.data.status) {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_course_posi_cordi/Id/' + item_course.id, '', headerAxios).then(res => {
                      if (res.data.status) {

                        this.$swal.fire({
                          icon: 'success',
                          title: 'ลบข้อมูลสำเร็จ'
                        })

                        this.GetPositionToShow()

                        CheckDelete = false

                        this.items.map((item) => {
                          item.name = item.LevelName
                          item.children = []
                        })
                      }
                    })
                  }
                })
              }
            })
          } else {
            if (CheckDelete) {
              if (dataPosition.status != 0) {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_course_posi_cordi/Id/' + item_age.id, '', headerAxios)
              } else {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_course_posi_cordi/Id/' + item_age.id, '', headerAxios)
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_position_cordi/Id/' + item_age.C_position_cordi_Id, '', headerAxios).then(res => {
                  if (res.data.status) {
                    Count++
                    CheckDelete = false

                    if (Count == dataPosition.children.length) {
                      this.$swal.fire({
                        icon: 'success',
                        title: 'ลบข้อมูลสำเร็จ'
                      })

                      this.GetPositionToShow()
                    }
                  }
                })
              }
            }
          }
          if (dataPosition.status != 0) {
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_position_cordi/Id/' + dataPosition.id, '', headerAxios).then(res => {
              if (res.data.status) {
                Count++
                CheckDelete = false

                if (Count == dataPosition.children.length) {
                  this.$swal.fire({
                    icon: 'success',
                    title: 'ลบข้อมูลสำเร็จ'
                  })

                  this.GetPositionToShow()
                }

                // this.items.map((item) => {
                //     item.name =  item.LevelName
                //     item.children = []
                // })
              }
            })
          }
        })
      } else {
        if (dataPosition.course != null) {
          if (CheckDelete) {
            const headerAxios = {
              headers: {
                'X-REST-METHOD': 'DELETE'
              }
            }
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_course_posi_cordi/Id/' + dataPosition.id, '', headerAxios).then(res => {
              if (res.data.status) {

                this.$swal.fire({
                  icon: 'success',
                  title: 'ลบข้อมูลสำเร็จ'
                })

                this.GetPositionToShow()

                CheckDelete = false

                // this.items.map((item) => {
                //     item.name =  item.LevelName
                //     item.children = []
                // })
              }
            })
          }
        } else {

          if (CheckDelete) {
            const headerAxios = {
              headers: {
                'X-REST-METHOD': 'DELETE'
              }
            }
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_position_cordi/Id/' + dataPosition.id, '', headerAxios).then(res => {
              if (res.data.status) {
                this.$swal.fire({
                  icon: 'success',
                  title: 'ลบข้อมูลสำเร็จ'
                })

                this.GetPositionToShow()

                CheckDelete = false

                // this.items.map((item) => {
                //     item.name = item.LevelName
                //     item.children = []
                // })
              }
            })
          }
        }
      }
    },
    GetPositionToShow() {
      this.WorkAgeData = []
      this.selection = []
      this.ChooseAgeData = ''
      this.initWorkExp({
        PosNew: this.position_c
      }).then(res_pos => {
        if (res_pos) {
            this.WorkAgeData = this.WorkExp
        } else {
          this.WorkAgeData = []
        }
      });
      this.PositionsData.map((posi_i) => {
        if (posi_i.PosCode == this.position_c) {
          this.PositionName = posi_i.PosName
        }
      })
    },
    GetManagerialToShow() {
      this.selection = []
      this.ManagerialData.map((posi_i) => {
        if (posi_i.supervisor_type_id == this.position_c) {
          this.PositionName = posi_i.supervisor_type_name
        }
      })
      this.selectionFunc()
      this.ChooseWorkAgeToCourse()
    },
    getCourseType() {
      this.Course.map((item) => {
        if (item.Course_code == this.Course_code) {
          this.course_group = item.Course_type_des
          this.Course_hour = item.Course_hour
          this.General_credit = item.General_credit
          this.departSel = item.Dep_Code
        }
      })
    },
    AddPositionExpert() {
      var DataInput = {
        PosCode: this.position_c,
        Position_level_ms_Id: this.posi_choose,
        Dep_Code: this.departSel,
        Create_By: this.MeData[0].perid
      }
      const headerAxios = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }

      if (this.position_c == '' || this.posi_choose == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณากรอกข้อมูลให้ครบถ้วน'
        })
      } else { // ผ่านเงื่อนไข

        // ServiceProvider.request('GET',ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_position_cordi').then((res) => {
        //     console.log(res)
        // })

        var CheckDataFromDB = []
        this.items.map((item) => {
          if (item.id == this.posi_choose) {
            CheckDataFromDB = item.children.filter(val => val.course.Course_code == this.Course_code)
          }
        })

        if (CheckDataFromDB.length == 0) {
          ServiceProvider.fetch('/hrtrain/C_position_cordi/PosCode/' + this.position_c).then((res) => {
            if (res.data.length > 0) {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_position_cordi', DataInput, headerAxios).then(res => { // บัยทึกช้อมูลลงตาราง
                if (res.data.status) {
                  axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_position_cordi_view/PosCode/' +
                      this.position_c + '/?sort=Id_DESC&limit=1').then(res_pos => {
                    if (res_pos.data) {

                      this.items.map((item) => {
                        if (item.id == this.posi_choose) {
                          DataInput = {
                            Course_code: this.Course_code,
                            C_position_cordi_Id: res_pos.data.Id
                          }
                          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_course_posi_cordi/', DataInput, headerAxios).then(res => {
                            if (res.data.status) {
                              this.$swal.fire({
                                icon: 'success',
                                title: 'บันทึกข้อมูลสำเร็จ'
                              })
                              var DepData = this.DepartData.filter(item => item.dep_id == this.departSel)
                              this.Course.map((Course_I) => {
                                if (Course_I.Course_code == this.Course_code) {
                                  if (DepData[0].dep_id == '35000') {
                                    item.children.push({
                                      id: item.children.length,
                                      position_id: res_pos.data.Id,
                                      Dep_Code: DepData[0].dep_id,
                                      name: Course_I.Course_name + '<span style="font-weight: bold;color: #6091ff"> ( ' + DepData[0].dep_name + ' ) </span> ',
                                      course: Course_I
                                    })
                                  } else {
                                    item.children.push({
                                      id: item.children.length,
                                      position_id: res_pos.data.Id,
                                      Dep_Code: DepData[0].dep_id,
                                      name: Course_I.Course_name + '<span style="font-weight: bold;color: #42b983"> ( หน่วยงาน : ' + DepData[0].dep_name + ' ) </span> ',
                                      course: Course_I
                                    })
                                  }

                                }
                              })
                              this.posi_choose_c = ''
                              this.age_choose_c = ''
                              this.Course_code = ''
                              this.Course_hour = ''
                              this.General_credit = ''
                            } else {
                              this.posi_choose_c = ''
                              this.age_choose_c = ''
                              this.Course_code = ''
                              this.Course_hour = ''
                              this.General_credit = ''
                            }

                            this.level_position = this.items.filter((item) => item.children.length > 0)
                          })
                        }
                      })

                      this.posi_choose = ''
                    }
                  })
                }
              })
            } else {

              /* var CountCredit = 0
               var DataInput = {}
               const headerAxios = {
                   headers: {
                       'Content-Type': 'application/json',
                       'X-REST-METHOD': 'PUT'
                   }
               }*/

              /*this.items.map((item) => { // วนลูป ตำแหน่ง
                  if (item.id == this.posi_choose_c) { // ถ้า ตำแหน่ง id = ระดับตำแหน่งที่เลือก
                      item.children.map((c_item, c_idx) => { // วนลูปค่า children
                          DataInput = {
                              Course_code: this.Course_code,
                              C_position_cordi_Id: c_item.C_position_cordi_Id
                          }
                          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_course_posi_cordi/', DataInput, headerAxios).then(res => {
                              if (res.data.status) {
                                  this.$swal.fire({
                                      icon: 'success',
                                      title: 'บันทึกข้อมูลสำเร็จ'
                                  })
                                  this.Course.map((Course_I) => {
                                      if (Course_I.Course_code == this.Course_code) {
                                          item.children[c_idx].children.push({
                                              id: item.children[c_idx].id,
                                              name: Course_I.Course_name + ' ( จำนวน <span style="color: #ff3531">' + Course_I.General_credit + '</span> เครดิต ) ' + '( ระยะเวลา <span style="color: #ff6d81">' + Course_I.Course_hour + ' </span> ช.ม. )',
                                              course: Course_I
                                          })
                                      }
                                  })
                                  item.children[c_idx].children.map((course_Item) => {
                                      CountCredit += parseInt(course_Item.course.General_credit)
                                  })
                                  this.ageItem.map((age_I) => {
                                      if (this.age_choose_c == age_I.id) {
                                          item.children[c_idx].name = 'อายุงาน ' + age_I.yearStart + ' - ' + age_I.yearEnd + ' ปี ( จำนวน <span style="color: #ff3531">' +
                                              item.children[c_idx].children.length + '</span> หลักสูตร <span style="color: #ff6d81">' + CountCredit + '</span> เครดิต )'
                                      }
                                  })
                                  this.posi_choose_c = ''
                                  this.age_choose_c = ''
                                  this.Course_code = ''
                                  this.Course_hour = ''
                                  this.General_credit = ''
                              } else {
                                  this.posi_choose_c = ''
                                  this.age_choose_c = ''
                                  this.Course_code = ''
                                  this.Course_hour = ''
                                  this.General_credit = ''
                              }
                          })
                      })
                  }
              })*/

              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_position_cordi', DataInput, headerAxios).then(res => { // บัยทึกช้อมูลลงตาราง
                if (res.data.status) {
                  axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_position_cordi_view/PosCode/' +
                      this.position_c + '/?sort=Id_DESC&limit=1').then(res_pos => {
                    if (res_pos.data) {
                      this.items.map((item) => {
                        if (item.id == this.posi_choose) {

                          DataInput = {
                            Course_code: this.Course_code,
                            C_position_cordi_Id: res_pos.data.Id
                          }
                          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_course_posi_cordi/', DataInput, headerAxios).then(res => {
                            if (res.data.status) {
                              this.$swal.fire({
                                icon: 'success',
                                title: 'บันทึกข้อมูลสำเร็จ'
                              })
                              var DepData = this.DepartData.filter(item => item.dep_id == this.departSel)
                              this.Course.map((Course_I) => {
                                if (Course_I.Course_code == this.Course_code) {
                                  if (DepData[0].dep_id == '35000') {
                                    item.children.push({
                                      id: item.children.length,
                                      position_id: res_pos.data.Id,
                                      Dep_Code: DepData[0].dep_id,
                                      name: Course_I.Course_name + '<span style="font-weight: bold;color: #6091ff"> ( ' + DepData[0].dep_name + ' ) </span> ',
                                      course: Course_I
                                    })
                                  } else {
                                    item.children.push({
                                      id: item.children.length,
                                      position_id: res_pos.data.Id,
                                      Dep_Code: DepData[0].dep_id,
                                      name: Course_I.Course_name + '<span style="font-weight: bold;color: #42b983"> ( หน่วยงาน : ' + DepData[0].dep_name + ' ) </span> ',
                                      course: Course_I
                                    })
                                  }

                                }
                              })
                              this.posi_choose_c = ''
                              this.age_choose_c = ''
                              this.Course_code = ''
                              this.Course_hour = ''
                              this.General_credit = ''
                            } else {
                              this.posi_choose_c = ''
                              this.age_choose_c = ''
                              this.Course_code = ''
                              this.Course_hour = ''
                              this.General_credit = ''
                            }

                            this.level_position = this.items.filter((item) => item.children.length > 0)
                          })
                        }
                      })

                      this.posi_choose = ''
                    }
                  })
                }
              })
            }
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่สามารถบันทึกข้อมูลได้เนื่องาก ตำแหน่งและหลักสูตรที่เลือก มีข้อมูลอยู่แล้ว'
          })
        }
      }
    },
    get_Age_Posi() {
      this.items.map((item, idx) => {
        if (item.id == this.posi_choose_c) {
          this.ageItem = this.items[idx].children
        }
      })
    },
    addCourseCondi(Id) {
      // var CountCredit = 0
      var DataInput = {}
      const headerAxios = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }

      this.items.map((item, idx) => { // วนลูป ตำแหน่ง
        if (item.LevelCode == this.posi_choose) { // ถ้า ตำแหน่ง id = ระดับตำแหน่งที่เลือก
          DataInput = {
            Course_code: this.Course_code,
            C_position_cordi_Id: Id
          }
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_course_posi_cordi/', DataInput, headerAxios).then(res => {
            if (res.data.status) {
              this.$swal.fire({
                icon: 'success',
                title: 'บันทึกข้อมูลสำเร็จ'
              })
              var DepData = this.DepartData.filter(item => item.dep_id == this.departSel)
              this.Course.map((Course_I) => {
                if (Course_I.Course_code == this.Course_code) {
                  if (DepData[0].dep_id == '35000') {
                    this.items[idx].children.push({
                      id: item.children.length,
                      position_id: Id,
                      Dep_Code: DepData[0].dep_id,
                      name: Course_I.Course_name + '<span style="font-weight: bold;color: #6091ff"> ( ' + DepData[0].dep_name + ' ) </span> ',
                      course: Course_I
                    })
                  } else {
                    this.items[idx].children.push({
                      id: item.children.length,
                      position_id: Id,
                      Dep_Code: DepData[0].dep_id,
                      name: Course_I.Course_name + '<span style="font-weight: bold;color: #42b983"> ( หน่วยงาน : ' + DepData[0].dep_name + ' ) </span> ',
                      course: Course_I
                    })
                  }
                }
              })
              // item.children.map((item_c, idx) => {
              //     if (item_c.Dep_Code == this.departSel) {
              //         item.children[idx].name += ' ( จำนวน <span style="color: #ff3531">' +
              //             item.children[idx].children.length + '</span> หลักสูตร <span style="color: #ff6d81">' + CountCredit + '</span> เครดิต )'
              //     }
              // })
              this.posi_choose_c = ''
              this.age_choose_c = ''
              this.Course_code = ''
              this.Course_hour = ''
              this.General_credit = ''
            } else {
              this.posi_choose_c = ''
              this.age_choose_c = ''
              this.Course_code = ''
              this.Course_hour = ''
              this.General_credit = ''
            }
          })
        }
      })

    },
    initAge() {
      for (var i = 0; i <= 100; i++) {
        this.AgeStart.push({
          id: i,
          value: i
        })
      }
      for (i = 1; i <= 100; i++) {
        this.AgeEnd.push({
          id: i,
          value: i
        })
      }
      this.AgeEnd.unshift({
        id: -1,
        value: 'เป็นต้นไป'
      })
    },
  },
  mounted() {
    this.changeColor({
      color: ConstData.defaultColorApp
    })
    this.changeHeaderName({
      headerName: ConstData.defaultHeaderApp
    })
    this.changeTypeProject({
      type: null
    })
    this.onResize()
    window.addEventListener('resize', this.onResize, {passive: true})
    this.initMeData().then(async res => {
      if (res) {
        await this.getIgnoreMenuPermissData({
          perid: this.MeData[0].perid,
          page_id: '13'
        })

        this.getMenuPermissData().then(res => {
          if (res) {
            if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '13' && item.page_status == '1').length > 0 || this.IgnoreMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
              this.maintain = false
              this.maintain = false
              this.getPermissionData({
                perid: this.MeData[0].perid
              }).then(res => {
                if (res) {
                  this.PermissionAdmin.map((Per_i, idx) => {
                    if (Per_i.permission_id == '3000') {
                      this.CheckAdmin = true

                      this.init()
                      this.initAge()
                    } else {
                      if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                        this.$router.push('/')
                      }
                    }
                  })
                } else {
                  // this.$router.push('/')
                  this.getPermissionUserData({
                    perid: this.MeData[0].perid
                  }).then(res => {
                    if (res) {
                      this.Permission.map((Per_i, idx) => {
                        if (Per_i.permission_id == '3000') {
                          this.CheckAdmin = true

                          this.init()
                          this.initAge()
                        } else {
                          if (!this.CheckAdmin && idx == this.Permission.length - 1) {
                            this.$router.push('/')
                          }
                        }
                      })
                    } else {
                      this.$router.push('/')
                    }
                  })
                }
              })
            } else {
              this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '13' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '13')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
              this.maintain = true
            }
          }
        }).then(err => {
          if (err) {
            this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '13' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '13')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
            this.maintain = true
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>
.v-label {
  color: black;
}

.v-card {
  border: 1px solid;
}

.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.v-text-field >>> button {
  font-size: 0.1em;
}
</style>
